import { render, staticRenderFns } from "./RoutinesForm.vue?vue&type=template&id=c7d0a7b0&scoped=true"
import script from "./RoutinesForm.vue?vue&type=script&lang=js"
export * from "./RoutinesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d0a7b0",
  null
  
)

export default component.exports